var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _i18n = _interopRequireDefault(require("../../../../../i18n"));

var _withDataFetch = _interopRequireDefault(require("../../../../../hoc/withDataFetch"));

var _index = _interopRequireDefault(require("../Events/index"));

var _Betting = _interopRequireDefault(require("../../../Betting"));

var _Voting = _interopRequireDefault(require("../../../Betting/Voting"));

var _Flatlist = _interopRequireDefault(require("../../../../Web/Flatlist"));

var _Basic = require("../../../../../elements/Basic");

var _LoadingSpinner = _interopRequireDefault(require("../../../Basic/LoadingSpinner"));

var _NoData = _interopRequireDefault(require("../../../Basic/DataFetching/NoData"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Liveticker/Commentary/Body/index.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Body = function (_React$Component) {
  (0, _inherits2.default)(Body, _React$Component);

  var _super = _createSuper(Body);

  function Body() {
    (0, _classCallCheck2.default)(this, Body);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Body, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          commentary = _this$props.commentary,
          onOutboundLinkClick = _this$props.onOutboundLinkClick,
          onPressVotingOption = _this$props.onPressVotingOption,
          competition = _this$props.competition,
          trackBwin = _this$props.trackBwin,
          bettingProviderLogo = _this$props.bettingProviderLogo,
          endReached = _this$props.endReached,
          endReachedMessageKey = _this$props.endReachedMessageKey,
          match = _this$props.match,
          header = _this$props.header,
          isFetching = _this$props.isFetching,
          onEndReached = _this$props.onEndReached,
          pageId = _this$props.pageId;
      var listFooterComponent;

      if (isFetching) {
        listFooterComponent = _react.default.createElement(_LoadingSpinner.default, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 87,
            columnNumber: 35
          }
        });
      } else if (endReached && endReachedMessageKey) {
        listFooterComponent = _react.default.createElement(_Basic.Text, {
          center: true,
          p: 3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 90,
            columnNumber: 17
          }
        }, (0, _i18n.default)(endReachedMessageKey));
      }

      return _react.default.createElement(_Flatlist.default, {
        scrollEventThrottle: 160,
        ListHeaderComponent: header,
        ListFooterComponent: listFooterComponent,
        ListEmptyComponent: _react.default.createElement(_Basic.Row, {
          display: "flex",
          center: true,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 21
          }
        }, _react.default.createElement(_NoData.default, {
          messageKey: match && match.period === 'PRE_MATCH' ? 'empty_message.PRE_LIVETICKER' : 'empty_message.LIVETICKER',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 25
          }
        })),
        removeClippedSubviews: true,
        webContentContainerStyle: {
          paddingTop: 8
        },
        initialNumToRender: 20,
        data: (0, _get.default)(commentary, 'content'),
        keyExtractor: function keyExtractor(item, index) {
          return item + index;
        },
        renderItem: function renderItem(_ref) {
          var item = _ref.item;
          var type = item.type,
              betModule = item.betModule;

          switch (type) {
            case 'BET_MODULE':
              return Body.renderBetModule((0, _get.default)(betModule, 'id'), competition, trackBwin, onOutboundLinkClick, onPressVotingOption, bettingProviderLogo, betModule, pageId);

            default:
              return _react.default.createElement(_index.default, (0, _extends2.default)({}, item.commentary, {
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 132,
                  columnNumber: 36
                }
              }));
          }
        },
        onEndReached: onEndReached,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 13
        }
      });
    }
  }], [{
    key: "renderBetModule",
    value: function renderBetModule(key, competition, trackBwin, onOutboundLinkClick, onPressVotingOption, bettingProviderLogo, betModule, pageId) {
      if (betModule.quotes) {
        return _react.default.createElement(_Betting.default, (0, _extends2.default)({
          key: key,
          competition: competition,
          trackBwin: trackBwin,
          onPress: onOutboundLinkClick,
          providerLogo: bettingProviderLogo,
          pageId: pageId
        }, betModule, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 42,
            columnNumber: 17
          }
        }));
      }

      return _react.default.createElement(_Voting.default, (0, _extends2.default)({}, _objectSpread({
        competition: competition,
        trackBwin: trackBwin,
        onOutboundLinkClick: onOutboundLinkClick,
        onPressOption: onPressVotingOption,
        providerLogo: bettingProviderLogo,
        pageId: pageId
      }, betModule), {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 54,
          columnNumber: 13
        }
      }));
    }
  }]);
  return Body;
}(_react.default.Component);

Body.propTypes = {
  commentary: _propTypes.default.object,
  header: _propTypes.default.object,
  match: _propTypes.default.object,
  isLoading: _propTypes.default.bool,
  error: _propTypes.default.object,
  isEmpty: _propTypes.default.bool,
  isFetching: _propTypes.default.bool,
  onOutboundLinkClick: _propTypes.default.func,
  onPressVotingOption: _propTypes.default.func,
  bettingProviderLogo: _propTypes.default.object,
  onEndReached: _propTypes.default.func,
  pageId: _propTypes.default.string
};

var _default = (0, _withDataFetch.default)(Body);

exports.default = _default;